import { useRuntimeConfig } from "#imports";
import type { NitroFetchOptions, NitroFetchRequest } from "nitropack";

export const baseApiUrl = (): string | undefined => {
	if (import.meta.server) return undefined;

	const getRuntimeConfig = useRuntimeConfig as typeof import("nuxt/app").useRuntimeConfig;
	const config = getRuntimeConfig();
	const apiBase = config.public?.apiBase;
	return typeof apiBase === "string" ? apiBase : "";
};

export const environmentAwareFetch = async <T>(
	url: string,
	options?: NitroFetchOptions<NitroFetchRequest>
): Promise<T> => {

	const baseURL = baseApiUrl();
	return await $fetch<T>(url, {
		baseURL,
		...options
	});
};